package com.kinoshazam.config

import com.kinoshazam.config.PlatformConfig.Platform

actual fun getPlatformConfig(): PlatformConfig =
    PlatformConfig(
        platform = Platform.WEB,
        version = AppVersion.NAME,
        buildNumber = AppVersion.CODE,
    )
